<template>
  <div class="RecycleBin">
    <div class="Header">
      <h2>回收站</h2>
      <div class="Actions">
        <div class="SearchBox">
          <i class="iconfont icon-search"></i>
          <input v-model="keyword" placeholder="搜索已删除文档..." />
          <i v-if="keyword" class="iconfont icon-close" @click="keyword = ''"></i>
        </div>
        <div class="RefreshBtn" @click="GetRecycleList">
          <i class="iconfont icon-refresh"></i> 刷新
        </div>
      </div>
    </div>
    
    <div class="Content">
      <div class="TableHead">
        <div class="Th Index">序号</div>
        <div class="Th Name">文档名称</div>
        <div class="Th Time">删除时间</div>
        <div class="Th Days">已删除天数</div>
        <div class="Th Ops">操作</div>
      </div>
      
      <div class="TableBody">
        <div v-if="filteredList.length === 0" class="EmptyState">
          <i class="iconfont icon-zanwujilu"></i>
          <span>{{ keyword ? '未找到相关文档' : '回收站空空如也' }}</span>
        </div>
        
        <div v-else class="TableRow" v-for="(item, index) in filteredList" :key="item.id">
          <div class="Td Index">{{ index + 1 }}</div>
          <div class="Td Name">
            <i :class="['iconfont', item.type === 0 ? 'icon-folder' : 'icon-markdown']" 
               :style="{ color: item.type === 0 ? '#dcb67f' : '#e2696c', marginRight: '8px' }"></i>
            {{ item.nodeName }}
          </div>
          <div class="Td Time">{{ FormatTime(item.updateTime) }}</div>
          <div class="Td Days">{{ item.deletedDays || 0 }} 天</div>
          <div class="Td Ops">
            <!-- 暂时禁用查看功能，因为后端未提供预览接口，且文档已删除 -->
            <!-- <button class="Btn View" @click="ViewDoc(item)">查看</button> -->
            <button class="Btn Restore" @click="RestoreDoc(item)">
              <img src="/icon/refresh.svg" class="BtnIcon">恢复
            </button>
            <button class="Btn Delete" @click="DeleteDoc(item)">
              <img src="/icon/delete_bin.svg" class="BtnIcon">彻底删除
            </button>
          </div>
        </div>
      </div>
    </div>

    <Dialog v-if="control.dialog.state" 
      :title="control.dialog.title"
      :content="control.dialog.content"
      :icon="control.dialog.icon"
      :acceptName="control.dialog.buttonName.accept"
      :cancelName="control.dialog.buttonName.cancel"
      :accept="control.dialog.accept"
      @dialogCancel="control.dialog.state = false">
    </Dialog>
  </div>
</template>

<script>
import Dialog from '../components/Dialog.vue'

export default {
  name: 'RecycleBin',
  components: { Dialog },
  data() {
    return {
      list: [],
      keyword: '',
      control: {
        dialog: {
          state: false,
          title: '',
          content: '',
          icon: '',
          buttonName: { accept: '确定', cancel: '取消' },
          accept: () => {}
        }
      }
    }
  },
  computed: {
    filteredList() {
      if (!this.keyword) return this.list
      const k = this.keyword.toLowerCase()
      return this.list.filter(item => 
        (item.nodeName && item.nodeName.toLowerCase().includes(k))
      )
    }
  },
  mounted() {
    this.$Common.SetDocTitle(this)
    this.GetRecycleList()
  },
  methods: {
    GetRecycleList() {
      this.$Common.SetLoading('正在加载回收站...')
      this.$Common.ApiList(this, 'RecycleBinList').then(url => {
        this.axios.get(url).then(res => {
          if (res.data.code === 200) {
            this.list = res.data.data || []
          } else {
            console.error(res.data.message)
          }
          this.$Common.RemoveLoading()
        }).catch(() => {
          this.$Common.NetworkErrorDialog(this)
        })
      })
    },
    FormatTime(timeStr) {
      if (!timeStr) return '-'
      return timeStr.replace('T', ' ').substring(0, 19)
    },
    RestoreDoc(item) {
      this.control.dialog = {
        state: true,
        title: '恢复确认',
        content: `确定要恢复 [${item.nodeName}] 吗？恢复后它将出现在原位置或根目录。`,
        icon: '/icon/refresh.svg',
        buttonName: { accept: '确认恢复', cancel: '取消' },
        accept: () => {
          this.$Common.ApiList(this, 'RecycleBinRestore').then(url => {
            // 后端接口：POST /doc/tree/recycle/restore/{id}
            const apiUrl = `${url}/${item.id}`
            this.axios.post(apiUrl).then(res => {
              if (res.data.code === 200) {
                this.control.dialog.state = false
                this.GetRecycleList()
                this.$emit('refresh-doc-tree')
                if (this.$Toast) this.$Toast('恢复成功', 'success')
              } else {
                if (this.$Toast) this.$Toast(res.data.message || '恢复失败', 'error')
                else alert(res.data.message || '恢复失败')
              }
            })
          })
        }
      }
    },
    DeleteDoc(item) {
      this.control.dialog = {
        state: true,
        title: '彻底删除',
        content: `警告：您正在彻底删除 [${item.nodeName}]，此操作不可逆！`,
        icon: '/icon/delete_bin.svg',
        buttonName: { accept: '彻底删除', cancel: '再想想' },
        accept: () => {
          this.$Common.ApiList(this, 'RecycleBinDelete').then(url => {
            // 后端接口：DELETE /doc/tree/recycle/remove/{id}
            const apiUrl = `${url}/${item.id}`
            this.axios.delete(apiUrl).then(res => {
              if (res.data.code === 200) {
                this.control.dialog.state = false
                this.GetRecycleList()
                if (this.$Toast) this.$Toast('删除成功', 'success')
              } else {
                if (this.$Toast) this.$Toast(res.data.message || '删除失败', 'error')
                else alert(res.data.message || '删除失败')
              }
            })
          })
        }
      }
    },
    ViewDoc() {
      // 预留功能
      if (this.$Toast) this.$Toast('文档已删除，请先恢复后查看', 'warning')
      else alert('文档已删除，请先恢复后查看')
    }
  }
}
</script>

<style scoped>
.RecycleBin {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  color: #333;
  padding: 20px;
  box-sizing: border-box;
}

.Header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.Header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: normal;
}

.Actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.SearchBox {
  display: flex;
  align-items: center;
  background: #f4f4f4;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 0 8px;
  height: 28px;
  width: 200px;
}

.SearchBox:focus-within {
  border-color: var(--ccs-primary-color);
  background: #fff;
}

.SearchBox input {
  background: transparent;
  border: none;
  color: #333;
  flex: 1;
  font-size: 13px;
  outline: none;
  padding: 0 5px;
}

.SearchBox i {
  font-size: 14px;
  color: #858585;
}

.SearchBox .icon-close {
  cursor: pointer;
}

.SearchBox .icon-close:hover {
  color: #333;
}

.RefreshBtn {
  cursor: pointer;
  padding: 5px 10px;
  background: #f4f4f4;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
}

.RefreshBtn:hover {
  background: #eee;
  color: var(--ccs-primary-color);
}

.Content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #eee;
  border-radius: 4px;
}

.TableHead {
  display: flex;
  background: #f7f7f7;
  padding: 10px 0;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  color: #333;
}

.TableBody {
  flex: 1;
  overflow-y: auto;
  background: #fff;
}

.TableRow {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  align-items: center;
  color: #333;
}

.TableRow:hover {
  background: #f9f9f9;
}

.Th, .Td {
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Index { width: 60px; text-align: center; }
.Name { flex: 1; display: flex; align-items: center; }
.Time { width: 180px; }
.Days { width: 100px; text-align: center; }
.Ops { width: 200px; display: flex; gap: 10px; justify-content: center; }

.Btn {
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.BtnIcon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  filter: brightness(0) invert(1);
}

.Btn.View { background: #409eff; }
.Btn.Restore { background: #67c23a; }
.Btn.Delete { background: #f56c6c; }

.Btn:hover { opacity: 0.8; }

.EmptyState {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
}

.EmptyState i {
  font-size: 64px;
  margin-bottom: 10px;
  color: #ccc;
}
</style>
